import ReactDOM from 'react-dom/client';
import './index.css';
// The phone app shell's global rules; all of them sit under the phone breakpoint.
import './mobile/mobile-app.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from 'react-router-dom';
// import { Auth0Provider } from "@auth0/auth0-react";
import { Provider } from 'react-redux';
import { store, persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { initAmplitude } from './utils/amplitudeInit';

// Initialize Amplitude + Session Replay at boot so the entire session is recorded.
initAmplitude();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <HashRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/sw.js`;
    navigator.serviceWorker.register(swUrl).catch(() => {
      // no-op: service worker is optional
    });
  });
}
